/**
 * プロセスグループ id / モデル名の形式チェック。
 *
 * ディレクトリ名になり、`<group>/<model>` の複合 id の一部として API のパスにも
 * 載るため、英小文字・数字・ハイフンだけに限る。スラッシュを弾くのは、group と
 * modelName を別々の欄で受け取る前提を崩さないため（片方に `a/b` と書けると
 * 意図しない階層ができる）。
 */
export const IDENTIFIER_PATTERN = "^[a-z0-9-]+$";

const IDENTIFIER_REGEX = new RegExp(IDENTIFIER_PATTERN);

/** 空（未入力）と形式不正は呼び出し側で出し分けたいので区別して返す。 */
export type IdentifierIssue = "ok" | "empty" | "invalid";

export function validateIdentifier(value: string): IdentifierIssue {
  const trimmed = value.trim();
  if (trimmed === "") return "empty";
  return IDENTIFIER_REGEX.test(trimmed) ? "ok" : "invalid";
}
